import classNames from 'classnames';
import { render } from 'storyblok-rich-text-react-renderer';
import { Button, COLOR_BRAND_BLUE_40, Conditional, IconChevronRight, Modal, Text } from '@consumidor-positivo/aurora';

import helpCircleIcon from '../../../assets/help-circle.svg';

import { SHOffer } from '../../../../../services/sortingHat';

import './styles.scss';
import { useMMHighlights } from './hook';

export type MMHighlightsProps = {
  offer: SHOffer;
  position: number;
};
export const MMHighlights = ({ offer, position }: MMHighlightsProps) => {
  const { annuityText, highlights, isAnnuityFree, modalData, handleCloseModal, handleModalData, shouldRenderSection } = useMMHighlights({
    offer,
    position,
  });

  const annuityClass = classNames('mm-highlights__annuity', {
    'mm-highlights__annuity--free': isAnnuityFree,
  });

  return (
    <div className="mm-highlights">
      <div className="mm-highlights__content">
        {Object.entries(highlights).map(([key, value], index) => {
          const mustRender = shouldRenderSection(key as keyof typeof highlights);
          return (
            <Conditional
              key={`highlight-${position}-${index}`}
              condition={mustRender}
              renderIf={
                <div className="mm-highlights__item">
                  <div className="mm-highlights__item-title">
                    <Text as="span" variant="body-medium">
                      {value.highlightTitle}
                    </Text>
                  </div>
                  <div className="mm-highlights__item-description">
                    <Conditional
                      condition={value?.hasModalInfo}
                      renderIf={
                        <Text as="button" variant="body-small" weight="bold" onClick={() => handleModalData(key as keyof typeof highlights)}>
                          {value?.highlightDescription}
                          <IconChevronRight rawColor={COLOR_BRAND_BLUE_40} size="small" />
                        </Text>
                      }
                      renderElse={
                        <Text as="span" variant="body-small" weight="bold">
                          {value.highlightDescription}
                        </Text>
                      }
                    />
                  </div>
                </div>
              }
            />
          );
        })}
      </div>

      <div className={annuityClass}>
        <Text as="p" variant="body-small" weight="semibold">
          {annuityText}
        </Text>

        <Conditional
          condition={Boolean(highlights?.annuity?.modalDescription)}
          renderIf={<img src={helpCircleIcon} alt="Icone de circulo com uma interrogação no meio" onClick={() => handleModalData('annuity')} />}
        />
      </div>

      <Conditional
        condition={modalData.isOpen}
        renderIf={
          <Modal
            isOpen={modalData.isOpen}
            onClose={handleCloseModal}
            content={
              <div className="mm-highlights__modal">
                <div className="mm-highlights__modal-content">
                  <Conditional
                    condition={Boolean(modalData.iconUrl)}
                    renderIf={
                      <div className="mm-highlights__modal-icon">
                        <img src={modalData.iconUrl || ''} alt="ícone de sessão" />
                      </div>
                    }
                  />
                  <div className="mm-highlights__modal-title">{render(modalData?.title || '')}</div>
                  <div className="mm-highlights__modal-description">{render(modalData?.content || '')}</div>
                </div>

                <Button onClick={handleCloseModal} type="outlined" expand="x">
                  Voltar
                </Button>
              </div>
            }
          />
        }
      />
    </div>
  );
};
